import { DarwinToolType, darwinToolTypeFromJSON } from "build-ts/darwin_agent";
import {
  ArtifactType,
  artifactTypeFromJSON,
  DarwinAgentType,
  ExecutionStatusType,
  executionStatusTypeFromJSON,
  ReasoningEffortLevel,
} from "build-ts/common";
import { ArtifactProto, ExecutionStepProto } from "build-ts/chat_session";
import { ScheduledJobProto } from "build-ts/schedule";

// Model options with their corresponding types
export const modelOptions = {
  openai: [
    {
      model_name: "gpt-4o",
      model_options: {
        reasoning: [],
      },
    },
    {
      model_name: "gpt-5",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.MINIMAL,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "gpt-5-mini",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.MINIMAL,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "gpt-5-pro",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.MINIMAL,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "gpt-5-nano",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.MINIMAL,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "gpt-5.1",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          // MINIMAL is unsupported in 5.1 - NONE can be used instead
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "gpt-5.2",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          // MINIMAL is unsupported in 5.2 - NONE can be used instead
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
          ReasoningEffortLevel.XHIGH,
        ],
      },
    },
    {
      model_name: "o3-pro",
      model_options: {
        reasoning: [ReasoningEffortLevel.LOW, ReasoningEffortLevel.MEDIUM, ReasoningEffortLevel.HIGH],
      },
    },
    {
      model_name: "o4-mini",
      model_options: {
        reasoning: [ReasoningEffortLevel.LOW, ReasoningEffortLevel.MEDIUM, ReasoningEffortLevel.HIGH],
      },
    },
    {
      model_name: "o3",
      model_options: {
        reasoning: [ReasoningEffortLevel.LOW, ReasoningEffortLevel.MEDIUM, ReasoningEffortLevel.HIGH],
      },
    },
    {
      model_name: "o3-mini",
      model_options: {
        reasoning: [ReasoningEffortLevel.LOW, ReasoningEffortLevel.MEDIUM, ReasoningEffortLevel.HIGH],
      },
    },
    {
      model_name: "o1",
      model_options: {
        reasoning: [ReasoningEffortLevel.LOW, ReasoningEffortLevel.MEDIUM, ReasoningEffortLevel.HIGH],
      },
    },
    {
      model_name: "gpt-5.4",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
          ReasoningEffortLevel.XHIGH,
        ],
      },
    },
    {
      model_name: "gpt-5.4-mini",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
          ReasoningEffortLevel.XHIGH,
        ],
      },
    },
    {
      model_name: "gpt-5.4-nano",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
          ReasoningEffortLevel.XHIGH,
        ],
      },
    },
    {
      model_name: "gpt-5.4-pro",
      model_options: {
        reasoning: [ReasoningEffortLevel.MEDIUM, ReasoningEffortLevel.HIGH, ReasoningEffortLevel.XHIGH],
      },
    },
  ],
  anthropic: [
    {
      model_name: "claude-opus-4-7",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
          ReasoningEffortLevel.XHIGH,
        ],
      },
    },
    {
      model_name: "claude-opus-4-6",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "claude-opus-4-1-20250805",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "claude-opus-4-20250514",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "claude-sonnet-4-6",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "claude-sonnet-4-20250514",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    {
      model_name: "claude-3-7-sonnet-20250219",
      model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ],
      },
    },
    { model_name: "claude-3-5-sonnet-20241022", model_options: {} },
    { model_name: "claude-3-5-sonnet-20240620", model_options: {} },
    { model_name: "claude-haiku-4-5-20251001", model_options: {} },
    { model_name: "claude-3-5-haiku-20241022", model_options: {} },
    { model_name: "claude-3-opus-20240229", model_options: {} },
    { model_name: "claude-3-sonnet-20240229", model_options: {} },
    { model_name: "claude-3-haiku-20240307", model_options: {} },
  ],
  google_genai: [
    { model_name: "gemini-2.0-flash", model_options: {} },
    { model_name: "gemini-2.0-flash-preview", model_options: {} },
    { model_name: "gemini-1.5-pro", model_options: {} },
    { model_name: "gemini-1.5-flash", model_options: {} },
    { model_name: "gemini-1.0-pro", model_options: {} },
  ],
  deepseek: [
    { model_name: "deepseek-chat", model_options: {} },
    { model_name: "deepseek-coder", model_options: {} },
    { model_name: "deepseek-r1", model_options: {} },
    { model_name: "deepseek-v3", model_options: {} },
  ],
};

export const getAgentTypeColorForDarwinEva = (type: DarwinAgentType | undefined) => {
  switch (type) {
    case DarwinAgentType.SCENARIO_SYNTHESIS_AGENT:
      return "blue";
    case DarwinAgentType.DATA_SCOPE_AGENT:
      return "green";
    case DarwinAgentType.SCENARIO_AGENT:
      return "yellow";
    case DarwinAgentType.ANALYST_CHAT_AGENT:
      return "purple";
    default:
      return "gray";
  }
};

export const getToolTypeColorForDarwinEva = (type: DarwinToolType | undefined) => {
  switch (type) {
    case DarwinToolType.AGENT_TOOL:
      return "gray";
    case DarwinToolType.RESPONSE_TOOL:
      return "yellow";
    case DarwinToolType.SKILL_TOOL:
      return "green";
    default:
      return "blue";
  }
};

export interface MessageWithToolsAndArtifacts {
  executionSteps?: ExecutionStepProto[];
  artifacts?: ArtifactProto[];
}

const isSaveScenarioStep = (step: ExecutionStepProto): boolean => {
  const status = executionStatusTypeFromJSON(step.status);
  const toolType = darwinToolTypeFromJSON(step.tool_type);
  return (
    status === ExecutionStatusType.SAVING_SCENARIO ||
    (status === ExecutionStatusType.TOOL_CALL_SUCCESS && toolType === DarwinToolType.SAVE_SCENARIO_TOOL)
  );
};

/**
 * Extract scenario jobs from messages where an AI tool call saved an analysis
 * (i.e. any tool whose name includes "save_analysis").
 */
export const extractScenarioJobsSavedByTools = (messages: MessageWithToolsAndArtifacts[]): ScheduledJobProto[] => {
  const jobs: ScheduledJobProto[] = [];

  for (const msg of messages) {
    if (!msg.artifacts) continue;
    const hasSaveJobTool = (msg.executionSteps ?? []).some(isSaveScenarioStep);
    if (!hasSaveJobTool) continue;

    for (const artifact of msg.artifacts) {
      if (artifactTypeFromJSON(artifact.artifact_type) !== ArtifactType.SCENARIO_JOB) continue;
      if (artifact.scenario_job) {
        jobs.push(artifact.scenario_job);
      }
    }
  }
  return jobs;
};

function humanizeExecutionStatusEnum(status: ExecutionStatusType | undefined): string {
  if (status === undefined) return "Thinking ...";
  const key = (ExecutionStatusType as unknown as Record<number, string>)[status];
  if (typeof key !== "string") return "Thinking ...";
  return (
    key
      .split("_")
      .map(w => w.charAt(0) + w.slice(1).toLowerCase())
      .join(" ") + " ..."
  );
}

/** Map an execution step to a human-readable loader / step label. */
export function getStreamingLabel(step: ExecutionStepProto): string {
  switch (step.status) {
    case ExecutionStatusType.IDLE_STATE:
      return "Waiting ...";
    case ExecutionStatusType.EXECUTING_LLM_CALL:
      return "Analyzing ...";
    case ExecutionStatusType.EXECUTING_TOOL_CALL: {
      switch (step.tool_type) {
        case DarwinToolType.DATAFRAME_TOOL:
          return "Querying data ...";
        case DarwinToolType.KG_OBSERVATION_DATA:
          return "Fetching observations ...";
        case DarwinToolType.GET_NODES_DATA:
          return "Fetching data ...";
        case DarwinToolType.SKILL_TOOL:
          return "Running analysis ...";
        case DarwinToolType.UPDATE_SCENARIO_METADATA_TOOL:
          return "Updating scenario ...";
        case DarwinToolType.SAVE_SCENARIO_TOOL:
          return "Saving scenario ...";
        case DarwinToolType.GET_SCENARIO_DETAIL_TOOL:
          return "Getting scenario details ...";
        case DarwinToolType.GET_PAST_JOB_RUNS:
          return "Fetching past job runs ...";
        case DarwinToolType.AGENT_TOOL:
          return "Running sub-agent ...";
        case DarwinToolType.SEARCH_WORKFLOW_RUNS_TOOL:
          return "Searching workflow runs ...";
        case DarwinToolType.SAVE_WORKFLOW_RUN_TOOL:
          return "Saving workflow run ...";
        case DarwinToolType.GET_WORKFLOW_RUN_DETAIL_TOOL:
          return "Loading workflow run ...";
        default:
          return "Calling tools ...";
      }
    }
    case ExecutionStatusType.VALIDATING_TOOL_CALL:
      return "Validating ...";
    case ExecutionStatusType.BUILDING_DATAFRAME:
      return "Building dataframe ...";
    case ExecutionStatusType.VALIDATING_DATAFRAME:
      return "Validating data ...";
    case ExecutionStatusType.EXECUTING_DATAFRAME:
      return "Executing dataframe ...";
    case ExecutionStatusType.FETCHING_PAST_JOB_RUNS:
      return "Fetching past job runs ...";
    case ExecutionStatusType.FETCHING_SCENARIO_DETAIL:
      return "Fetching scenario detail ...";
    case ExecutionStatusType.LOADING_SCENARIO_MANAGEMENT_SKILL:
      return "Loading scenario management ...";
    case ExecutionStatusType.LOADING_SCENARIO_SYNTHESIS_SKILL:
      return "Loading scenario synthesis ...";
    case ExecutionStatusType.UPDATING_SCENARIO_METADATA:
      return "Updating scenario metadata ...";
    case ExecutionStatusType.BUILDING_KG_OBSERVATION:
      return "Building observation ...";
    case ExecutionStatusType.EXECUTING_KG_OBSERVATION:
      return "Executing observation ...";
    case ExecutionStatusType.SAVING_SCENARIO:
      return "Saving scenario ...";
    case ExecutionStatusType.BUILDING_ANALYSIS_OUTPUT:
      return "Building analysis output ...";
    case ExecutionStatusType.FETCHING_ANALYSIS_OUTPUT:
      return "Fetching analysis output ...";
    case ExecutionStatusType.SEARCHING_WORKFLOW_RUNS:
      return "Searching workflow runs ...";
    case ExecutionStatusType.SAVING_WORKFLOW_RUN:
      return "Saving workflow run ...";
    case ExecutionStatusType.LOADING_WORKFLOW_RUN:
      return "Loading workflow run ...";
    case ExecutionStatusType.SUCCESS:
      return "Finished";
    case ExecutionStatusType.TOOL_CALL_SUCCESS:
      return "Tool completed ...";
    case ExecutionStatusType.ERROR_STATE:
    case ExecutionStatusType.TOOL_CALL_FAILURE:
      return "Something went wrong ...";
    default:
      return humanizeExecutionStatusEnum(step.status);
  }
}

/**
 * Triggers a browser file download for the given URL and filename.
 *
 * Works with both data URLs (e.g. canvas.toDataURL) and object URLs
 * (e.g. URL.createObjectURL). Object URLs are revoked after the click
 * to release memory; calling revokeObjectURL on a data URL is a safe no-op.
 */
export function triggerDownload(url: string, filename: string): void {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}

/** Min/max `timestamp_ms` across steps (ignores steps with missing timestamps). */
export function minMaxExecutionStepTimestampsMs(steps: ExecutionStepProto[]): { minMs: number; maxMs: number } | null {
  if (!steps.length) return null;
  let tMin: number | undefined;
  let tMax: number | undefined;
  for (const s of steps) {
    const t = s.timestamp_ms;
    if (t === undefined) continue;
    if (tMin === undefined || t < tMin) tMin = t;
    if (tMax === undefined || t > tMax) tMax = t;
  }
  if (tMin === undefined || tMax === undefined) return null;
  return { minMs: tMin, maxMs: tMax };
}

/** Human-readable duration from a millisecond delta (same rules as tool run spans). */
export function formatDurationFromDeltaMs(deltaMs: number): string | null {
  if (deltaMs < 800) return "<1s";
  const totalSec = Math.round(deltaMs / 1000);
  if (totalSec < 60) return `${totalSec}s`;
  const m = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${m}m ${sec}s`;
}

/** Wall-clock span of a tool run from first to last step `timestamp_ms` (e.g. `12s`, `2m 5s`). */
export function formatToolRunDuration(steps: ExecutionStepProto[]): string | null {
  const bounds = minMaxExecutionStepTimestampsMs(steps);
  if (!bounds) return null;
  return formatDurationFromDeltaMs(bounds.maxMs - bounds.minMs);
}

/** Human-readable file size (e.g. `1.4 KB`, `2.3 MB`). */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
